import { render } from "./PhoneNumber.vue?vue&type=template&id=1ae035bd"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts"

import "./PhoneNumber.vue?vue&type=style&index=0&id=1ae035bd&lang=css"
script.render = render

export default script